import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";

// Thunks
import {
  geteceactivityskillThunk,
  createeceskillmasterThunk,
  updateeceskillmasterThunk,
  deleteeceskillmasterThunk,
} from "./EceSkillsetManager.Thunk";

import {
  updatepgeskillmasterThunk,
  deletepgeskillmasterThunk,
} from "../pge_skillset_manager/PgeSkillsetManager.Thunk";

import {
  preferedlanguage_change,
  class_change,
  subject_change,
} from "./EceSkillsetManager.Slice";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// swal
import Swal from "sweetalert2";
import { Language } from "@mui/icons-material";

function EceSkillsetManagerPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];
  //   const subject_select_option_list = [
  //     { value: "math", text: "Math" },
  //     { value: "english", text: "English" },
  //     { value: "odia", text: "Odia" },
  //     { value: "evs", text: "EVS" },
  //   ];
  const class_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    // { value: "4", text: "4" },
    // { value: "5", text: "5" },
  ];
  // ------------------------------------------

  const [usertype_change_ece, set_usertype_change_ece] = useState("");

  // ------------ dropdowns on change ----------------
  const preflanguage_select_onchange = (event) => {
    dispatch(preferedlanguage_change(event.target.value));
  };
  const prefusertype_select_onchange = (event) => {
    set_usertype_change_ece(event.target.value);
  };
  //   const subject_select_onchange = (event) => {
  //     dispatch(subject_change(event.target.value));
  //   };
  const class_select_onchange = (event) => {
    dispatch(class_change(event.target.value));
    //  const params = { event.target.value };
    dispatch(geteceactivityskillThunk(event.target.value));
  };
  // -------------------------------------------------

  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.PgeSkillsetManagerSlice.loading);
  // ---------------------------------------------

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  ////console.log("selectedSkillsetId----->", selectedSkillsetId);
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, skillid, skillname, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(skillid);
    setSelectedSkillsetName(skillname);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // --------------------- data --------------------------
  const data = useSelector((state) => state.EceSkillsetManagerSlice.data);
  //console.log("eceskillse---->", data);
  // -----------------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/eceactivity");
  };
  // ------------------------------------------------------------

  // ------------ Load data & skill ----------------
  const program = "ece";
  const preferedlanguage = useSelector(
    (state) => state.EceSkillsetManagerSlice.preferedlanguage
  );
  const subject = useSelector((state) => state.EceSkillsetManagerSlice.subject);
  const clas = useSelector((state) => state.EceSkillsetManagerSlice.clas);
  const disable_content_button = useSelector(
    (state) => state.EceSkillsetManagerSlice.disable_content_button
  );

  // useEffect(() => {
  //   const load_data = () => {
  //     if (
  //       preferedlanguage.length > 0 &&
  //       usertype_change_ece.length > 0 &&
  //       clas.length > 0
  //     ) {
  //       const params = { clas };
  //       dispatch(geteceactivityskillThunk(params));
  //     }
  //   };
  //   load_data();
  // }, [dispatch, preferedlanguage, subject, clas]);
  // -----------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    Swal.fire({
      title: "CREATE NEW THEME",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid theme name");
        else {
          const body = {
            preferedlanguage,
            usertype_change_ece,
            class: clas,
            skillid: new Date().getTime(),
            skillname: input_value,
          };
          // //console.log("input------>", body);
          dispatch(createeceskillmasterThunk(body)).then(() => {
            // const params = { clas };
            dispatch(geteceactivityskillThunk(clas));
            toast.success("Changes made successfully");
          });
        }
      },
    });
  };

  const update_content_button_click = (_id, skillname, skillid) => {
    handleVertMenuClose();
    Swal.fire({
      title: "UPDATE THEME",
      input: "text",
      inputValue: skillname,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === skillname) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          const params = {
            skillid: skillid,
            body: {
              skillname: input_value,
            },
          };
          //  //console.log("params---->",params)
          dispatch(updateeceskillmasterThunk(params)).then(() => {
            const params = { clas };
            dispatch(geteceactivityskillThunk(clas));
            toast.success("Changes made successfully");
          });
        }
      },
    });
  };

  const delete_content_button_click = (skillid) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteeceskillmasterThunk(skillid)).then(() => {
          const params = { clas };
          dispatch(geteceactivityskillThunk(clas));
          toast.success("Changes made successfully");
        });
      }
    });
  };
  // -------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="ECE Skillset Manager" />

        <FormControl
          sx={{ m: 1, minWidth: 120 }}
          style={{ marginTop: 84 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={preferedlanguage}
            label="Language"
            onChange={preflanguage_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1, minWidth: 120 }}
          style={{ marginTop: 84 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype_change_ece}
            label="Language"
            onChange={prefusertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          sx={{ m: 1, minWidth: 120 }}
          style={{ marginTop: 84 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Class</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={clas}
            label="Class"
            onChange={class_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {class_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small">Themes</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={subject}
            label="Subject"
            onChange={subject_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {subject_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{ m: 1, minWidth: 120, marginTop: 0 }}
          size="small">
          ECE Activities
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Button
        style={{marginTop: -30}}
          onClick={create_content_button_click}
          variant="contained"
          disabled={disable_content_button}
        >
          Create New Skills
        </Button>
        {preferedlanguage.length > 0 &&
        usertype_change_ece.length > 0 &&
        clas.length > 0 ? (
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={3}>
              {data.map((eachskill, index) => (
                <Grid
                  item
                  xs={12}
                  sm={isSmallScreen ? 12 : 6}
                  md={4}
                  key={index}
                >
                  <Card sx={{ maxWidth: 345 }}>
                    <CardHeader
                      avatar={
                        <Avatar sx={{ bgcolor: purple[500] }}>
                          <AodIcon />
                        </Avatar>
                      }
                      action={
                        <>
                          <IconButton
                            id={index + 1.1}
                            onClick={(e) =>
                              handleVertMenuClick(
                                e,
                                eachskill._id,
                                eachskill.skillid,
                                eachskill.skillname,
                                index
                              )
                            }
                            aria-controls={openVertMenu ? { index } : undefined}
                            aria-expanded={openVertMenu ? "true" : undefined}
                            aria-haspopup="true"
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </>
                      }
                      title={
                        <div style={{ cursor: "pointer" }}>
                          {eachskill.skillname}
                        </div>
                      }
                      subheader={
                        <div style={{ cursor: "pointer" }}>
                          {eachskill.skillid ? eachskill.skillid : ""}
                        </div>
                      }
                    />
                    {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
                  </Card>
                </Grid>
              ))}
              <Menu
                id={selectedIndex}
                anchorEl={anchorEl}
                open={openVertMenu}
                onClose={handleVertMenuClose}
                MenuListProps={{
                  "aria-labelledby": "vert-button",
                }}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: "20ch",
                  },
                }}
              >
                <MenuItem
                  onClick={() =>
                    update_content_button_click(
                      recordId,
                      selectedSkillsetName,
                      selectedSkillsetId
                    )
                  }
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    delete_content_button_click(selectedSkillsetId)
                  }
                >
                  Delete
                </MenuItem>
              </Menu>
            </Grid>
          </Box>
        ) : null}
      </div>

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default EceSkillsetManagerPage;
